import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import Card from "./Card";

type Story = ComponentStory<typeof Card>;

const commonArgs: React.ComponentProps<typeof Card> = {
    title: "Type",
    children: "Active"
};

export default {
    title: "common/Card",
    component: Card,
    args: commonArgs
} as ComponentMeta<typeof Card>;

const Template: Story = args => <Card {...args} />;

export const Default = Template.bind({});
